export const mockProps = {
  modelValue: false,
  name: 'checkboxName',
  label: 'Label text',
  labelHidden: false,
  size: 'md',
};